import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext } from "@nuxtjs/composition-api";


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguagesDropdown',
  setup(__props) {

const context = useContext();
const currentLocale = computed(() => context.i18n.locale);

return { __sfc: true,context, currentLocale }
}

})